import api from './client';

/**
 * Phase 20 — Private Live Dashboard API.
 * All endpoints filter strictly by the current user's id.
 */

export const dashboardOverview = async () => {
  const res = await api.get('/lives/dashboard/overview');
  return res.data;
};

export const dashboardFuture = async () => {
  const res = await api.get('/lives/dashboard/future');
  return res.data;
};

export const dashboardHistory = async () => {
  const res = await api.get('/lives/dashboard/history');
  return res.data;
};

export const dashboardOneToOne = async () => {
  const res = await api.get('/lives/dashboard/one-to-one');
  return res.data;
};

export const dashboardCalendar = async ({ start, end } = {}) => {
  const res = await api.get('/lives/dashboard/calendar', {
    params: { start, end },
  });
  return res.data;
};

export const dashboardStats = async () => {
  const res = await api.get('/lives/dashboard/stats');
  return res.data;
};

// Pannello di controllo — VIP read-only summary (earnings by source, sales
// counts, saves received on racconti).
export const creatorSummary = async () => {
  const res = await api.get('/dashboard/creator-summary');
  return res.data;
};
